// Template Marketplace verification (admin-portal / platform console). Operators
// review SUBMITTED workforce-framework listings and verify (list) or suspend them.
// Goes through the gateway to workforce-framework-service; the operator's platform
// role carries workforce:marketplace:verify (enforced downstream).
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface MarketplaceListing {
  id: string;
  framework_id: string;
  owner_tenant_id: string;
  title: string;
  summary?: string;
  category?: string;
  industry?: string;
  region?: string;
  status: string; // submitted | listed | suspended
  featured: boolean;
  rating_avg: number;
  rating_count: number;
  license_type?: string;
  price_amount?: number | null;
  price_currency?: string;
  billing_period?: string;
  created_at?: string;
}

export const getPendingListings = (): Promise<MarketplaceListing[]> =>
  axios.get<{ listings: MarketplaceListing[] }>(`${API_V1}/marketplace/pending`).then((r) => r.data.listings || []);

export const verifyListing = (id: string): Promise<MarketplaceListing> =>
  axios.post<MarketplaceListing>(`${API_V1}/marketplace/${id}/verify`).then((r) => r.data);

export const suspendListing = (id: string, reason?: string): Promise<MarketplaceListing> =>
  axios.post<MarketplaceListing>(`${API_V1}/marketplace/${id}/suspend`, { reason }).then((r) => r.data);
